'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PresentationRecord from '../../records/PresentationRecord';
import Loadable from 'UIComponents/decorators/Loadable';
import UnstyledButton from '../UnstyledButton';
import { getDarkBrandingColor } from '../../utils/color';
import { MAIN_CONTENT_ANCHOR } from '../../lib/constants';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import ViewToolbarLogo from './toolbar/ViewToolbarLogo';
import ViewToolbarDivider from './ViewToolbarDivider';
import styled from 'styled-components';
const StyledSkipNav = styled.a.withConfig({
  displayName: "ViewToolbar__StyledSkipNav",
  componentId: "sc-127nse3-0"
})(["position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;"]);
const LoadableViewActions = Loadable({
  loader: () => import(
  /* webpackChunkName: "view-secondary-content" */
  './ViewActions')
});

const ViewToolbar = ({
  presentation,
  meetingLink,
  fetchDownloadLink,
  onPageDrawerToggle
}) => {
  const {
    primaryColor,
    secondaryColor,
    logoAltText,
    companyName
  } = presentation.brandingMetadata;
  const brandingColor = getDarkBrandingColor(primaryColor, secondaryColor);
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    justify: "between",
    className: "view-toolbar p-x-10",
    "data-test-id": "view-toolbar",
    style: {
      borderColor: brandingColor
    },
    children: [/*#__PURE__*/_jsx(ViewToolbarLogo, {
      logoUrl: presentation.brandingMetadata.logoUrl,
      logoAltText: logoAltText,
      companyName: companyName
    }), /*#__PURE__*/_jsx(StyledSkipNav, {
      onClick: () => {
        document.getElementById(MAIN_CONTENT_ANCHOR).focus();
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "a11y.skipToDocument"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "align-center",
      children: [/*#__PURE__*/_jsx(UnstyledButton, {
        "aria-hidden": "true",
        className: "p-x-1 m-x-2",
        "data-test-id": "page-drawer-toggle-button",
        onClick: onPageDrawerToggle,
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "grid",
          color: brandingColor,
          size: "xs"
        })
      }), /*#__PURE__*/_jsx(ViewToolbarDivider, {}), /*#__PURE__*/_jsx(LoadableViewActions, {
        brandingColor: brandingColor,
        presentation: presentation,
        fetchDownloadLink: fetchDownloadLink,
        meetingLink: meetingLink
      })]
    })]
  });
};

ViewToolbar.propTypes = {
  presentation: PropTypes.instanceOf(PresentationRecord),
  meetingLink: PropTypes.string,
  fetchDownloadLink: PropTypes.func.isRequired,
  onPageDrawerToggle: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(ViewToolbar);